/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_List_Filter_Recruits_Have_VeknInputs */



/**
* | output |
* | --- |
* | "Members you recruited always have a VEKN ID" |
*
* @param {User_List_Filter_Recruits_Have_VeknInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_filter_recruits_have_vekn = /** @type {((inputs?: User_List_Filter_Recruits_Have_VeknInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_Filter_Recruits_Have_VeknInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vos recrues ont toujours un identifiant VEKN")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sus reclutas siempre tienen un identificador VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Seus recrutas sempre têm um ID VEKN")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le Sue reclute hanno sempre un ID VEKN")
	return /** @type {LocalizedString} */ ("Members you recruited always have a VEKN ID")
});